export { Router as default } from 'react-router';


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-router-dom/es/Router.js
// module id = 1193
// module chunks = 0